<script setup lang="ts">
  import HeaderUseCaseMenu from '@/components/header/UseCaseMenu.vue';
  import HeaderUseCaseMenuMobile from '@/components/header/UseCaseMenuMobile.vue';
  import HeaderLocaleSelector from '@/components/header/LocaleSelector.vue';

  const viewport = useViewport();

  const chatStore = useChatStore();
  const { isAiMode } = storeToRefs(chatStore);

  const { serviceMenuItems, socials } = await useSharedContent();
</script>

<template>
  <div class="default-layout">
    <AppHeader :is-mobile="viewport.isLessThan('lg')">
      <template #left>
        <HeaderLocaleSelector />
      </template>
      <template #center>
        <HeaderUseCaseMenu
          v-if="!isAiMode && viewport.isGreaterOrEquals('lg')"
          :items="serviceMenuItems" />
      </template>
      <template #bottom>
        <HeaderUseCaseMenuMobile :items="serviceMenuItems" />
      </template>
    </AppHeader>
    <slot />
    <AppFooter :socials="socials" />
  </div>
</template>
